import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import ImgOrVideo from "./ImgOrVideo";
import { getDomainInfo } from "../utils/utils";
import { FaRegStar, FaStar } from "react-icons/fa";

function ProductsMapList({ productList, handleOpenDrawer }) {
  const { productId , userId} = useParams();
  const {uid}=getDomainInfo(userId);

  const StarRating = ({ rating }) => {
    return (
      <div className="star-box">
        {[...Array(5)].map((_, index) =>
          index < rating ? <FaStar key={index} /> : <FaRegStar key={index} />
        )}
      </div>
    );
  };

  return (
    <Grid container rowSpacing={2} columnSpacing={{ xs: 4, sm: 4, md: 5 }} className={productList && productList?.length <4?'justify-content-center':''}>
      {productList &&
        productList.map((item, index) => {
          if (item.id === productId) return null;

          return (
            <Grid item xs={6} key={index} className="prductListGrid d-block">
              <div className="ProductItem">
                <ImgOrVideo url={item.images?.[0]} uid={uid} pid={item.id} productName={item.title?.replace(/\s+/g, "_")} skuId={item.skuId} />
                <button
                  className="plus-sign-product"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenDrawer(item);
                  }}
                >
                  +
                </button>
              </div>

              <p className="ProductFontTitle" title={item.title}>
                {item.title?.length > 20
                  ? item.title.slice(0, 20) + "..."
                  : item.title}
              </p>
              <div className="product-des p-0">
                <div className="star-icons">
                  <ul>
                    <li><StarRating rating={Math.round(item.avgRating)} /></li>
                  </ul>
                  <p>({item.totalReviews})</p>
                </div>
              </div>

              <div className="price-section">
                <span className="new-price">
                  &#8377; {(item.price > 0 ? item.price : item.mrp).toLocaleString("en-IN")}
                </span>
                {item.price > 0 && (
                  <span className="old-price">
                    &#8377; {item.mrp.toLocaleString("en-IN")}
                  </span>
                )}
              </div>
            </Grid>
          );
        })}
    </Grid>
  );
}

export default ProductsMapList;
